import { withViewModel } from './hocs/withViewModel';
export var connector = {
    buildConnectedComponent: function (Component, ViewModel) {
        return withViewModel(ViewModel)(Component);
    },
};
